/**
 * App-v2.js — Feature branch router
 * Branch: feature/seo-preservation-homepage-modernization
 *
 * Changes from App.js:
 *  - Route "/" renders HomeV2 (new modern homepage)
 *  - The modern enterprise header/footer are shared globally across the V2 shell.
 *  - ALL other routes are unchanged — zero URL removals, zero slug changes.
 *
 * DO NOT merge into main without review.
 */
import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import "./assets/css/homepage-v2.css";
import "./assets/css/industry-v2.css";
import "./assets/css/product-heritage-v2.css";

/* ── New homepage ── */
import HomeV2 from "./screens/home-v2";
import NewNavbar from "./components/home/new-navbar";
import NewFooter from "./components/home/new-footer";

/* ── All existing screens — untouched ── */
import About from "./screens/company/about";
import Management from "./screens/company/management";
import ExpertiseExperience from "./screens/company/expertise-experience";
import Advantage from "./screens/company/advantage";
import ValueProposition from "./screens/company/value-proposition";
import DXchange from "./screens/products/dxchange";
import UmrahBookingSolution from "./screens/products/umrah-booking-solution";
import TravelAndHospitality from "./screens/products/travel-hospitality";
import Insurance from "./screens/products/insurance";
import Healthcare from "./screens/products/healthcare";
import Legal from "./screens/products/legal";
import BizRuleEngine from "./screens/products/biz-rule-engine";
import CARMA from "./screens/products/carma";
import CMS from "./screens/products/cms";
import OnlineExamination from "./screens/products/online-examination";
import MoreProducts from "./screens/products/more-products";
import EnterpriseAI from "./screens/enterprise-ai";
import ITConsultingServices from "./screens/services/it-consulting-services";
import ManagedServices from "./screens/services/managed-services";
import DedicatedEngineeringTeams from "./screens/services/dedicated-engineering-teams";
import LegacyModernization from "./screens/services/legacy-modernization";
import EnterpriseAIEnablement from "./screens/services/enterprise-ai-enablement";
import DesignSuite from "./screens/services/design-suite";
import MicrosoftTechnologies from "./screens/services/microsoft-technologies";
import DotNetNukeDevelopment from "./screens/services/dotnetnuke-development";
import ProjectManagement from "./screens/services/project-management";
import JavaDevelopment from "./screens/services/java-development";
import QualityAssurance from "./screens/services/quality-assurance";
import InternationalAcceptance from "./screens/customers/international-acceptance";
import InternationalProjects from "./screens/customers/international-projects";
import DomesticProjects from "./screens/customers/domestic-projects";
import Objective from "./screens/partners/objective";
import Benefits from "./screens/partners/benefits";
import PartnersProgram from "./screens/partners/partners-program";
import News from "./screens/news/news";
import Events from "./screens/news/events";
import Membership from "./screens/news/membership";
import InsightsListing from "./screens/resources/insights";
import InsightDetail from "./screens/blog/insight-detail";
import InsightsAdmin from "./screens/admin/insights";
import Careers from "./screens/careers/careers";
import ContactUs from "./screens/contact/contact-us";
import NotFound from "./screens/not-found";
import ReactGA from "react-ga";

ReactGA.initialize("UA-5235714-2");

class AppV2 extends Component {
  state = {};

  componentDidUpdate() {
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    return (
      <React.Fragment>
        {/* Shared enterprise header for homepage and all modernized routes */}
        <NewNavbar />

        <Switch>
          {/* ── Homepage: new implementation ── */}
          <Route exact path="/" component={HomeV2} />

          {/* ── All existing routes: unchanged ── */}
          <Route path="/about" component={About} />
          <Route path="/management" component={Management} />
          <Route path="/expertise-experience" component={ExpertiseExperience} />
          <Route path="/advantage" component={Advantage} />
          <Route path="/value-proposition" component={ValueProposition} />
          <Route path="/dxchange" component={DXchange} />
          <Route path="/umrah-booking-solution" component={UmrahBookingSolution} />
          <Route path="/travel-hospitality" component={TravelAndHospitality} />
          <Route path="/insurance" component={Insurance} />
          <Route path="/healthcare" component={Healthcare} />
          <Route path="/legal" component={Legal} />
          <Route path="/biz-rule-engine" component={BizRuleEngine} />
          <Route path="/carma" component={CARMA} />
          <Route path="/cms" component={CMS} />
          <Route path="/online-examination" component={OnlineExamination} />
          <Route path="/more-products" component={MoreProducts} />
          <Route path="/enterprise-ai" component={EnterpriseAI} />
          <Route path="/it-consulting-services" component={ITConsultingServices} />
          <Route path="/services/managed-services" component={ManagedServices} />
          <Route path="/services/dedicated-engineering-teams" component={DedicatedEngineeringTeams} />
          <Route path="/services/legacy-modernization" component={LegacyModernization} />
          <Route path="/services/enterprise-ai-enablement" component={EnterpriseAIEnablement} />
          <Route path="/design-suite" component={DesignSuite} />
          <Route path="/microsoft-technologies" component={MicrosoftTechnologies} />
          <Route path="/dotnetnuke-development" component={DotNetNukeDevelopment} />
          <Route path="/project-management" component={ProjectManagement} />
          <Route path="/java-development" component={JavaDevelopment} />
          <Route path="/quality-assurance" component={QualityAssurance} />
          <Route path="/international-acceptance" component={InternationalAcceptance} />
          <Route path="/international-projects" component={InternationalProjects} />
          <Route path="/domestic-projects" component={DomesticProjects} />
          <Route path="/objective" component={Objective} />
          <Route path="/benefits" component={Benefits} />
          <Route path="/partners-program" component={PartnersProgram} />
          <Route exact path="/resources/insights" component={InsightsListing} />
          <Route exact path="/blog" component={InsightsListing} />
          <Route path="/blog/:slug" component={InsightDetail} />
          <Route path="/news" component={News} />
          <Route path="/events" component={Events} />
          <Route path="/membership" component={Membership} />
          <Route exact path="/admin/insights" component={InsightsAdmin} />
          <Route path="/careers" component={Careers} />
          <Route path="/contact-us" component={ContactUs} />
          {/* Catch-all: unknown URLs render a noindex 404 page (nginx returns 404 status for non-route paths) */}
          <Route component={NotFound} />
        </Switch>

        <NewFooter />
      </React.Fragment>
    );
  }
}

export default withRouter(AppV2);
